// Export legacy hook for direct access
export { useUserSubscription as useLegacyUserSubscription } from './useUserSubscription';

export {
  UserPlanType,
  subscriptionTypeToPlanTypeMap,
  type UseUserSubscriptionReturnType,
} from './useUserSubscription.types';

export { getUserPlanType } from './helpers/getUserPlanType';

// Export wrapper as useUserSubscription to limit number of code changes where it's used
export { useUserSubscription } from './useUserSubscriptionWrapper';
